import { useState, useEffect } from 'react';
import { X, Sparkles } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const CURRENT_VERSION = '2026-04-13';

const NEW_FEATURES = [
  '🌱 Germination tracking — get reminded to check if your seeds sprouted',
  '🔄 Retry or give up on failed sowings with automatic timeline adjustment',
  '✅ Completed tasks now auto-sort to the bottom of your daily list',
];

export function WhatsNewBanner() {
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    const seen = localStorage.getItem('whats-new-seen');
    if (seen !== CURRENT_VERSION) {
      setDismissed(false);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem('whats-new-seen', CURRENT_VERSION);
    setDismissed(true);
  };

  return (
    <AnimatePresence>
      {!dismissed && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.3 }}
          className="rounded-2xl border border-primary/20 bg-primary/5 p-4 relative overflow-hidden"
        >
          <button
            onClick={handleDismiss}
            className="absolute top-3 right-3 text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Dismiss"
          >
            <X className="h-4 w-4" />
          </button>

          <div className="flex items-start gap-3 pr-6">
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-primary/10">
              <Sparkles className="h-4 w-4 text-primary" />
            </div>
            <div>
              <h3 className="text-sm font-semibold text-foreground mb-1.5">What's New</h3>
              <ul className="space-y-1">
                {NEW_FEATURES.map((feature, i) => (
                  <li key={i} className="text-xs text-muted-foreground leading-relaxed">
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
